/**
 * pacingEditorState — open/closed state of the self-service daily/weekly
 * pacing editor (IonUsageMeter.jsx's `PacingEditor`).
 *
 * A signal rather than local component state because the editor now has an
 * entry point OUTSIDE its own tree: a button in the Ion header
 * (ChatPanelHeader.jsx). Same reason capabilityGalleryState.js is a signal.
 *
 * Why it moved to the header at all: the pacing control used to be a bare
 * underlined link inside the usage-meter tile, and that tile rendered for
 * PRO/batemo even when no budget window was anywhere near its cap — purely so
 * the link had somewhere to live. The result was a full-width strip under the
 * header containing one sentence and one link, which is what BA saw and called
 * "verloren". A control belongs with the other controls; a meter belongs where
 * meters go. Splitting them lets the strip disappear entirely when there is no
 * meter worth showing.
 */

import { signal } from '@preact/signals'

export const pacingEditorOpen = signal(false)

export function openPacingEditor() {
  pacingEditorOpen.value = true
}

export function closePacingEditor() {
  pacingEditorOpen.value = false
}

export function togglePacingEditor() {
  pacingEditorOpen.value = !pacingEditorOpen.value
}
